export const ListaKompanijaResourcesEN: ListaKompanijaResourcesBSInterface = {
  title: "Companies",
  listaTacaka: "Application points",
  listaRadnihTacaka: "Workplace and users",
  branchButton: "Select branch",
  next: "Forward",
  back: "Back",
  branch: {
    placeholder: "Select branch",
    notFound: "Branch not found",
  },
  errorBranches:
    "An error occurred during loading. Please contact the administrator.",
};

export interface ListaKompanijaResourcesBSInterface {
  title: string;
  listaTacaka: string;
  listaRadnihTacaka: string;
  branchButton: string;
  next: string;
  back: string;
  branch: {
    placeholder: string;
    notFound: string;
  };
  errorBranches: string;
}
